import { useQuery } from '@tanstack/react-query';
import { edupassClient } from '../@clients';
import type { InstitutionsSearchResult } from './interfaces';

export const useInstitutionsSearch = () => {
  const result = useQuery<{ data: InstitutionsSearchResult }>({
    queryKey: ['useInstitutionsSearch'],
    queryFn: async () => {
      return edupassClient.get('/institutions/search');
    },
  });

  return {
    ...result,
    institutions: result.data?.data.items.sort((a, b) =>
      a.name.localeCompare(b.name)
    ),
  };
};
